import React, { useState } from 'react'
import styles from './WarningMessage.module.scss'
import { ScrollableContainer } from 'components/common'
import { IconErrorSmall, IconWarningSmall } from 'assets'
import WarningLine from './WarningLine'
import { Props, WarningLevel, WarningTypes } from './types'
import { getWarningLevel, validateObject } from './utils'

const WarningMessage = (props: Props) => {
  const [showInfo, setShowInfo] = useState(false)

  const warnings = validateObject(props)
  const warningLevel = warnings.map(getWarningLevel).some(l => l === WarningLevel.ERROR)
    ? WarningLevel.ERROR
    : WarningLevel.WARNING

  const Icon = {
    [WarningLevel.ERROR]: IconErrorSmall,
    [WarningLevel.WARNING]: IconWarningSmall
  }[warningLevel]

  return warnings.length
    ? (
      <div
        className={styles.container}
        onMouseEnter={() => setShowInfo(true)}
        onMouseLeave={() => setShowInfo(false)}
      >
        {/* <Icon
          icon={icons.exclamationMark}
          className={styles.warningIcon}
        /> */}
        <Icon />

        {showInfo &&
          <ScrollableContainer className={styles.infoContainer} style={ { overflow: 'hidden' } }>
            {warnings.map((warning: WarningTypes) =>
              <WarningLine
                key={warning}
                warning={warning}
                objectType={props.objectType}
              />
            )}
          </ScrollableContainer>
        }

      </div>
    )
    : null
}

export default WarningMessage
